import { observable } from 'mobx';
import guid from '../../../../utils/guid';

export default class Thumb {
  @observable id;
  @observable date_created;
  @observable s3;

  constructor({ id = guid(), date_created = new Date(), s3 = '' }) {
    this.id = id;
    this.date_created = date_created;
    this.s3 = s3;
  }
}



// WEBPACK FOOTER //
// ./src/containers/analyse/store/model/Thumb.js